/* =====================================================================
   Ashley Stewart · UI review fixes (Oct 2026) — product page, collection & search
   Presentation only. Re-arranges existing markup; never rewrites copy.
   Each feature is gated by window.ASUI.flags (Theme settings).
   ===================================================================== */
(function () {
  'use strict';
  var CFG = window.ASUI || { flags: {}, reviews: {} };
  var F = CFG.flags || {};
  var html = document.documentElement;
  var mqMobile = window.matchMedia('(max-width: 767px)');

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function onReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function waitFor(selector, cb, timeoutMs) {
    var found = $(selector);
    if (found) return cb(found);
    var obs = new MutationObserver(function () {
      var n = $(selector);
      if (n) { obs.disconnect(); cb(n); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, timeoutMs || 20000);
  }
  function safe(name, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[ASUI] ' + name, e); } }

  /* ---------------- scroll lock + focus trap helpers ---------------- */
  var lastFocus = null;
  function lock(on) { html.classList.toggle('as-lock', on); }

  /* =================================================================
     PDP-1 / PDP-2 · Compact Yotpo reviews
     ================================================================= */
  function initReviews() {
    if (!F.reviewsCompact || CFG.template !== 'product') return;
    waitFor('.yotpo-reviews-main-widget', function (widget) {
      var panel = widget.closest('.shopify-app-block') || widget.closest('.yotpo-widget-instance');
      var section = widget.closest('.shopify-section') || panel.parentElement;
      if (!panel || section.classList.contains('as-rv')) return;
      section.classList.add('as-rv');
      panel.classList.add('as-rv__panel');
      panel.id = panel.id || 'as-reviews';
      panel.setAttribute('aria-label', 'Reviews');

      var count = parseInt(CFG.reviews && CFG.reviews.count, 10) || 0;
      var avg = parseFloat(CFG.reviews && CFG.reviews.avg) || 0;

      // Read the live numbers from Yotpo if the metafield lags behind.
      function readYotpo() {
        var sc = $('.yotpo-bottom-line-score', widget);
        var txt = $('.yotpo-bottom-line-basic-text', widget);
        var a = sc ? parseFloat(sc.textContent) : NaN;
        var c = txt ? parseInt((txt.textContent.match(/[\d,]+/) || ['0'])[0].replace(/,/g, ''), 10) : NaN;
        if (!isNaN(a) && a > 0) avg = a;
        if (!isNaN(c) && c > 0) count = c;
      }
      readYotpo();

      function stars(v) {
        var full = Math.floor(v), half = v - full >= 0.5 ? 1 : 0, out = '';
        for (var i = 0; i < 5; i++) out += i < full ? '★' : (i === full && half ? '⯨' : '☆');
        return out;
      }

      // One-row summary (mobile + zero reviews)
      var row = el('button', { type: 'button', class: 'as-rv-row', 'aria-haspopup': 'dialog', 'aria-controls': panel.id });
      function paintRow() {
        row.innerHTML = '';
        if (count > 0) {
          row.appendChild(el('span', null, [
            el('span', { class: 'as-rv-row__stars', 'aria-hidden': 'true', text: stars(avg) }),
            el('span', { class: 'as-rv-row__score', text: avg.toFixed(1) }),
            el('span', { class: 'as-rv-row__sep', 'aria-hidden': 'true', text: '·' }),
            el('span', { text: count + (count === 1 ? ' review' : ' reviews') })
          ]));
          row.setAttribute('aria-label', 'Rated ' + avg.toFixed(1) + ' out of 5, ' + count + ' reviews. Open reviews');
        } else {
          row.appendChild(el('span', null, [
            el('span', { text: 'No reviews yet' }),
            el('span', { class: 'as-rv-row__sep', 'aria-hidden': 'true', text: '·' }),
            el('span', { class: 'as-rv-row__cta', text: 'Write the first one' })
          ]));
          row.removeAttribute('aria-label');
        }
        row.appendChild(el('span', { class: 'as-rv-row__chev', 'aria-hidden': 'true', text: '›' }));
      }
      paintRow();
      panel.parentNode.insertBefore(el('h2', { class: 'as-rv__title', text: 'Reviews' }), panel);
      panel.parentNode.insertBefore(row, panel);

      // "See all N reviews" under the compact block (desktop)
      var more = el('div', { class: 'as-rv__more' });
      var seeAll = el('button', { type: 'button', class: 'as-rv__btn', 'aria-haspopup': 'dialog', 'aria-controls': panel.id });
      function paintMore() { seeAll.textContent = count > 3 ? 'See all ' + count + ' reviews' : 'See reviews'; more.hidden = count <= 3; }
      paintMore();
      more.appendChild(seeAll);
      panel.parentNode.insertBefore(more, panel.nextSibling);

      // Drawer close bar
      var close = el('button', { type: 'button', class: 'as-rv__close' }, [
        el('span', { text: 'Reviews' }),
        el('span', { class: 'as-rv__close-x', 'aria-hidden': 'true', text: '×' })
      ]);
      close.setAttribute('aria-label', 'Close reviews');
      panel.insertBefore(close, panel.firstChild);

      var scrim = null;
      function open(opts) {
        if (section.classList.contains('as-rv--open')) return;
        lastFocus = document.activeElement;
        section.classList.add('as-rv--open');
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        scrim = el('div', { class: 'as-rv__scrim' });
        scrim.addEventListener('click', shut);
        document.body.appendChild(scrim);
        lock(true);
        panel.scrollTop = 0;
        close.focus({ preventScroll: true });
        if (opts && opts.write) {
          var b = $('.yotpo-new-review-btn', panel);
          if (b) setTimeout(function () { b.click(); }, 50);
        }
      }
      function shut() {
        section.classList.remove('as-rv--open');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        if (scrim) { scrim.remove(); scrim = null; }
        lock(false);
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      // "Write a review": go straight to Yotpo's form. Yotpo renders the form at the end of <body>,
      // so our drawer is closed first; otherwise the form would sit behind it.
      function writeReview() {
        var b = $('.yotpo-new-review-btn', widget);
        if (!b) { open(); return; }
        if (section.classList.contains('as-rv--open')) shut();
        b.click();
      }
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.yotpo-new-review-btn');
        if (!b || !panel.contains(b) || !section.classList.contains('as-rv--open')) return;
        // Let Yotpo handle the click, then close our drawer so its form is on top.
        setTimeout(shut, 0);
      }, true);
      row.addEventListener('click', function () { if (count === 0) writeReview(); else open(); });
      seeAll.addEventListener('click', function () { open(); });
      close.addEventListener('click', shut);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && section.classList.contains('as-rv--open')) shut();
        if (e.key === 'Tab' && section.classList.contains('as-rv--open')) {
          var f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', panel).filter(function (n) { return n.offsetParent !== null; });
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
      });

      // Star rating near the title opens reviews instead of scrolling to a hidden block.
      document.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('.yotpo-reviews-star-ratings-widget, .yotpo-star-rating-reviews-summary-link, .yotpo-sr-bottom-line-summary');
        if (!t || panel.contains(t)) return;
        if (mqMobile.matches || count === 0) { e.preventDefault(); e.stopPropagation(); if (count === 0) writeReview(); else open(); }
      }, true);

      function applyZero() { section.classList.toggle('as-rv--zero', count === 0); }
      applyZero();

      // Yotpo renders asynchronously; refresh the numbers once it settles.
      var mo = new MutationObserver(function () {
        var before = count;
        readYotpo();
        if ($('.yotpo-review', widget)) { if (count === 0) count = Math.max(1, $$('.yotpo-review', widget).length); }
        if (count !== before) { paintRow(); paintMore(); applyZero(); }
      });
      mo.observe(widget, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);

      if (/^#(reviews|yotpo|as-reviews)/.test(location.hash)) open();
    });
  }

  /* SHOP-1 / SHOP-2 · Search: tidy suggestions, hide junk filter values */
  function initSearchUi() {
    if (!F.searchUi) return;
    function norm(t) {
      return t.toLowerCase().replace(/[^a-z0-9 ]/g, ' ').split(/\s+/).filter(Boolean)
        .map(function (w) { return /(ss|ch|sh|x)es$/.test(w) ? w.slice(0, -2) : (/[^s]s$/.test(w) ? w.slice(0, -1) : w); }).sort().join(' ');
    }
    function tidySuggestions(root) {
      $$('.search-suggestions-list', root).forEach(function (ul) {
        var seen = {}, shown = 0;
        $$(':scope > li', ul).forEach(function (li) {
          var k = norm(li.textContent || '');
          var dup = !k || seen[k];
          seen[k] = true;
          var hide = dup || shown >= 5;
          li.classList.toggle('as-hide', hide);
          if (!hide) shown++;
        });
      });
    }
    var JUNK = /^(#ref!|null|n\/a|undefined|#n\/a|#value!)$/i;
    function hideJunkFilters(root) {
      $$('.facets__list li, .facets-list li, .sidebarBlock li', root).forEach(function (li) {
        var lab = li.querySelector('label, a, .facet-checkbox__text, .facets__label') || li;
        var t = (lab.textContent || '').replace(/\(\d+\)/g, '').trim();
        if (JUNK.test(t)) li.classList.add('as-hide');
      });
    }
    var pending = false;
    function schedule(fn) { if (pending) return; pending = true; setTimeout(function () { pending = false; fn(); }, 150); }
    // Suggestions: watch only the predictive-search result boxes.
    $$('form.search, form[action*="/search"], predictive-search, .predictive-search').forEach(function (box) {
      if (box.closest('.as-menu-search, .as-404-search')) return;
      new MutationObserver(function () { schedule(function () { tidySuggestions(box); }); })
        .observe(box, { childList: true, subtree: true });
    });
    // Filters: only on search and collection pages, and only inside the filter sidebar / product grid wrapper.
    if (/^(search|collection)$/.test(CFG.template)) {
      hideJunkFilters(document);
      var fRoot = $('#CollectionProductGrid') ? $('#CollectionProductGrid').parentNode : null;
      var side = $('.halo-sidebar-wrapper, .page-sidebar, .sidebarBlock');
      [fRoot, side && side.parentNode].forEach(function (r) {
        if (!r) return;
        new MutationObserver(function () { schedule(function () { hideJunkFilters(r); }); }).observe(r, { childList: true, subtree: true });
      });
    }
  }

  /* #2 / #13 / #14 · Phone galleries sized to the photo (PDP + Quick View) */
  function arOf(img) {
    if (!img) return 0;
    var w = parseFloat(img.getAttribute('width')) || img.naturalWidth, h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
    return w > 0 && h > 0 ? w / h : 0;
  }
  function refreshSlick(root) {
    var $j = window.jQuery;
    if (!$j || !root) return;
    $$('.slick-initialized', root).forEach(function (n) { try { $j(n).slick('setPosition'); } catch (e) {} });
  }
  function initGalleryFit() {
    if (!F.mobileGallery) return;
    var mq = window.matchMedia('(max-width: 767px)');
    if (CFG.template === 'product') {
      var wrap = $('.productView-images .productView-image-wrapper, .productView-image-wrapper');
      var img = wrap && $('.productView-nav img', wrap);
      var ar = arOf(img);
      if (ar && Math.abs(ar - (parseFloat(getComputedStyle(html).getPropertyValue('--asui-ar')) || 0)) > 0.01) {
        html.style.setProperty('--asui-ar', ar.toFixed(4));
      }
      if (mq.matches && wrap) { refreshSlick(wrap); setTimeout(function () { refreshSlick(wrap); }, 400); }
      if (wrap) {
        var setH = function () {
          if (!mq.matches) { wrap.classList.remove('as-imgh'); return; }
          var im = $('.productView-nav .slick-current img', wrap) || $('.productView-nav img', wrap);
          if (im && im.offsetHeight > 40) { wrap.style.setProperty('--asui-img-h', im.offsetHeight + 'px'); wrap.classList.add('as-imgh'); }
        };
        setH();
        $$('.productView-nav img', wrap).forEach(function (i) { if (!i.complete) i.addEventListener('load', setH, { once: true }); });
        window.addEventListener('resize', function () { setTimeout(setH, 100); });
        if (window.jQuery) window.jQuery(wrap).find('.productView-nav').on('afterChange setPosition', function () { setTimeout(setH, 30); });
        setTimeout(setH, 600); setTimeout(setH, 2000);
      }
    }
    var qv = document.getElementById('halo-quick-view-popup');
    if (!qv) return;
    var content = $('.halo-popup-content', qv) || qv;
    var busy = false;
    function fit() {
      busy = false;
      var img = $('.productView-nav img', content);
      var a = arOf(img);
      if (!a) return;
      qv.style.setProperty('--asui-qv-ar', a.toFixed(4));
      if (mq.matches) { refreshSlick(content); setTimeout(function () { refreshSlick(content); }, 350); }
    }
    new MutationObserver(function () { if (!busy) { busy = true; setTimeout(fit, 120); } }).observe(content, { childList: true });
  }

  onReady(function () {
    safe('gallery', initGalleryFit);
    safe('reviews', initReviews);
    safe('searchUi', initSearchUi);
  });
})();
